import {isDefined} from "@/utils";

export const supportedLanguages = ['de', 'en'];

export default {

  getCurrentLang(){
    let lang = null;
    const html = document.getElementsByTagName("html");
    if (html && html.length > 0) {
      lang = html[0].getAttribute("lang");
    }
    if(lang === 'en-EN'){
      lang = 'en';
    }else if(lang === 'de-DE'){
      lang = 'de';
    }

    if(isDefined(lang) && supportedLanguages.findIndex(l => l === lang) > -1){
      return lang;
    }
    return "en";
  }

}
